import Seo from "../components/Seo";
import ArticleCard from "../components/ArticleCard";
import CtaBand from "../components/CtaBand";
import { Reveal, Eyebrow } from "../components/Reveal";
import { SITE } from "../data/site";
import ARTICLES from "../data/articles";

export default function ResourcesIndex() {
  const sorted = [...ARTICLES].sort((a, b) => b.date.localeCompare(a.date));
  return (
    <>
      <Seo
        title="Security Guides & Resources | The Intel Desk | Xtreme Protection England"
        description="Practical security guides for England: security guard costs, SIA licensing, manned guarding vs patrols, construction site security, key holding & more — written by practitioners."
        keywords="security guides England, security guard cost, SIA licence guide, security resources, loss prevention guide, event security checklist, BS 7858 vetting"
        canonical={`${SITE.domain}/resources`}
      />

      <section className="tactical-grid border-b border-white/10" data-testid="resources-hero">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
          <Reveal>
            <Eyebrow>The Intel Desk // Guides & Resources</Eyebrow>
            <h1 className="font-display font-black uppercase leading-[0.95] tracking-tight text-5xl sm:text-6xl lg:text-7xl text-white max-w-4xl">
              Security intelligence, in plain English
            </h1>
            <p className="mt-6 max-w-2xl text-base sm:text-lg text-gray-300 leading-relaxed">
              Practical guides on guarding costs, SIA licensing, patrol strategy
              and sector security across England — written by the people who run
              the shifts, not by a marketing template.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-testid="resources-grid-section">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="resources-grid">
          {sorted.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.06}>
              <ArticleCard article={a} />
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand
        title="Rather talk it through with a human?"
        text={`Skip the reading — call our England command centre on ${SITE.phone} and get a straight answer on your site in five minutes.`}
      />
    </>
  );
}
